import * as React from "react";
import { StyleSheet, View, Image, Text, Dimensions } from "react-native";
import CharitiesList from "../../components/CharitiesGrid";
import CharityActions from "../../redux/actions/CharityActions";
import { useSelector } from "react-redux";
import GlobalStyles from "../../components/GlobalStyles";
import FooterBarWide from "../../components/footerBarWide";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import BackButton from "../../components/BackButton";

export default function DonateCharitiesListingScreen() {
  const charitiesLoaded = useSelector((state) => state.charity.charitiesLoaded);
  if (!charitiesLoaded) {
    CharityActions();
  }
  const charities = useSelector((state) => state.charity.charities);
  const win = Dimensions.get("window");
  return (
    <View style={GlobalStyles.containerMB}>
      {win.width > 768 ? (
        <View style={GlobalStyles.fullHeaderBarY}>
          <MenuBar data="5" />
          <View style={GlobalStyles.topHeaderTitelContainerForWeb}>
            <View style={[GlobalStyles.headerContainerKLYellow, { alignSelf: "flex-start" }]}>
              <View style={GlobalStyles.headerTextYellowForweb}>
                <View style={GlobalStyles.backIconContainerForWeb} >
                  <BackButton />
                </View>
                <View>
                  <Text style={GlobalStyles.headingStyle}>Support a Charity</Text>
                  <Text style={GlobalStyles.subheaderStyleWeb}>Start by selecting your preferred Charity below.</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      ) : (
        <View style={GlobalStyles.fullHeaderBarW}>
          <StatusBar data="BM" />
          <View style={GlobalStyles.headerContainerKL}>
            <View style={[GlobalStyles.headerText]}>
              <Text style={GlobalStyles.headingStyle}>Support a Charity</Text>
              <View style={styles.boxSubHeader}>
                <View style={styles.boxSubHeaderColA}>
                  <Text style={GlobalStyles.subheaderStyle}>
                    Start by selecting your preferred Charity below.
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      )}
      <View style={win.width < 768 ? GlobalStyles.bodyContainerCards : GlobalStyles.adjustableBodyContainer}>
        {/* <View style={GlobalStyles.adjustableBodyContainer}> */}
        <View style={styles.boxContainer}>
          <View style={styles.headerTextB}>
            <Text style={styles.bodyStyle}>
              Donate to your favourite charitable organisation, at no cost to
              you! Aura donates a percentage of the price of all your eligible
              purchases.
            </Text>
          </View>
          <CharitiesList data={charities.filter((val) => val.type === 0)} />
        </View>
      </View>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  boxSubHeader: {
    flex: 1,
    flexDirection: "row",
    width: "100%",
    minWidth: 290,
  },
  boxSubHeaderColA: {
    //flex: 4,
    alignItems: "flex-start",
    //padding: 5,
    //width: "100%",
  },
  boxSubHeaderColB: {
    flex: 2,
    padding: 5,
    width: "100%",
  },
  fullHeaderBar: {
    borderBottomLeftRadius: 80,
    backgroundColor: "#FFC72C",
  },
  boxContainer: {
    flex: 1,
    backgroundColor: "#FFFF",
    marginLeft: 15,
    marginTop: 15,
    marginRight: 15,
    marginBottom: 0,
    paddingTop: 15,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  headerTextB: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 25,
  },
  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 14,
    textAlign: "left",
    marginBottom: 5,
    lineHeight: 20,
    marginLeft: 20,
    marginRight: 20,
  },
  theList: {
    flex: 1,
    alignItems: "center",
  },
  Amount: {
    fontFamily: "montserrat-bold",
    fontSize: 20,
    textAlign: "center",
    marginBottom: 5,
    color: "#4EBDEF",
  },
  subTextDonated: {
    fontFamily: "montserrat-regular",
    fontSize: 7,
    textAlign: "center",
    color: "#998FA2",
  },
});
